import { render, staticRenderFns } from "./PaperInfo.vue?vue&type=template&id=fb87c436&"
import script from "./PaperInfo.vue?vue&type=script&lang=js&"
export * from "./PaperInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports